import {
  resolveListingRecordWorkspace,
  resolveListingScopeNo,
} from './listingWorkspaceMeta';

/** 套图模板作用域（对齐 AI 文案：个人 / 团队 / 官方） */
export const IMAGE_TEMPLATE_SCOPES = [
  { key: 'personal', label: '个人' },
  { key: 'team', label: '团队' },
  { key: 'official', label: '官方' },
];

export const DEFAULT_IMAGE_TEMPLATE_SCOPE = 'official';

function resolveRecordOwnerId(record) {
  const raw = record?.ownerUserId ?? record?.ownerId ?? record?.owner_id ?? record?.createdByUserId;
  return raw != null && raw !== '' ? String(raw) : '';
}

/** 解析套图模板作用域：official / team / personal */
export function resolveImageTemplateScope(record) {
  if (!record || typeof record !== 'object') return 'personal';
  if (record.official === true || record.scope === 'official') return 'official';
  if (record.scope === 'team' || record.scope === 'personal') return record.scope;
  return resolveListingRecordWorkspace(record) === 'team' ? 'team' : 'personal';
}

export function filterImageTemplatesByScope(templates, scopeKey = DEFAULT_IMAGE_TEMPLATE_SCOPE) {
  const key = String(scopeKey || DEFAULT_IMAGE_TEMPLATE_SCOPE);
  return (templates || []).filter((t) => resolveImageTemplateScope(t) === key);
}

/** 可见作用域 Tab：个人+官方始终；团队按权限 */
export function resolveVisibleImageTemplateScopes(canAccessTeam = false) {
  return IMAGE_TEMPLATE_SCOPES.filter(
    (item) => item.key !== 'team' || Boolean(canAccessTeam),
  );
}

/**
 * 快捷选模板：按用户/团队 ACL 过滤可读模板。
 * - official：始终可读
 * - personal：仅本人（ownerUserId / userNo / scopeNo）
 * - team：需 canAccessTeam，且 teamId 或 teamNo 匹配
 */
export function filterImageTemplatesByUserTeamAccess(records, access = {}) {
  const list = Array.isArray(records) ? records : [];
  const {
    authUserId = null,
    userNo = '',
    canAccessTeam = false,
    teamId = null,
    teamNo = '',
  } = access;
  const currentUserNo = String(userNo || '').trim();
  const currentTeamNo = String(teamNo || '').trim();
  const authId = authUserId != null && authUserId !== '' ? String(authUserId) : '';

  return list.filter((record) => {
    const scope = resolveImageTemplateScope(record);
    if (scope === 'official') return true;

    if (scope === 'personal') {
      if (!authId && !currentUserNo) return false;
      const ownerId = resolveRecordOwnerId(record);
      if (authId && ownerId && ownerId === authId) return true;
      const recordScopeNo = resolveListingScopeNo(record);
      const recordUserNo = String(record?.userNo || record?.user_no || '').trim();
      if (currentUserNo) {
        if (recordUserNo && recordUserNo === currentUserNo) return true;
        if (recordScopeNo && recordScopeNo === currentUserNo) return true;
      }
      return false;
    }

    // team
    if (!canAccessTeam) return false;
    const recordTeamId = record?.teamId ?? record?.team_id;
    if (teamId != null && recordTeamId != null && String(recordTeamId) === String(teamId)) {
      return true;
    }
    const recordScopeNo = resolveListingScopeNo(record);
    if (currentTeamNo && recordScopeNo && recordScopeNo === currentTeamNo) {
      return true;
    }
    // 历史数据：团队模板但缺少 teamId/编号时，仅创建者本人可见（有团队标识则不得跨团队）
    const hasTeamIdentity = (recordTeamId != null && recordTeamId !== '') || Boolean(recordScopeNo);
    if (!hasTeamIdentity && authId) {
      const ownerId = resolveRecordOwnerId(record);
      if (ownerId && ownerId === authId) return true;
    }
    return false;
  });
}

/** 为列表项打上 scope，供弹窗 Tab 计数 */
export function annotateImageTemplateScopes(records) {
  return (Array.isArray(records) ? records : []).map((record) => ({
    ...record,
    scope: resolveImageTemplateScope(record),
  }));
}
